import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const CategorySection = styled.div`
  display: flex;
  flex-direction: column;
  > div:last-child {
    margin-bottom: 0px;
  }
`;

const ContainerCategory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: ${({ device }) => (device === 'mobile' ? '16px' : '0')};
  .section {
    display: flex;
    flex-direction: column;
  }
`;

const CategoryTitle = styled.h3`
  font-family: Hind;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${select('black')};
`;

const CheckboxGroup = styled.div`
  display: grid;
  grid-template-columns: ${({ device }) => (device === 'mobile' ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)')};
  gap: 8px;
  min-height: ${({ twoRows }) => (twoRows ? '88px' : '40px')};
  max-height: ${({ maxHeight }) => `calc(${maxHeight} + 0.5px)`};
  transition: max-height 0.3s ease-in-out;
  overflow: hidden;
`;

const Separator = styled.div`
  height: 1px;
  background-color: ${select('neutralDarkGray')};
  margin: 24px 0;
`;

export { CategorySection, ContainerCategory, CategoryTitle, CheckboxGroup, Separator };
